export interface MarketingHubNavItem {
    id: number;
    slug: string;
    title: string;
}

export interface MarketingHubSection {
    index: number;
    title: string | null;
    content: string | null;
    linkText: string | null;
    resourceUrl: string | null;
    image1Url: string | null;
    image2Url: string | null;
}

export interface MarketingHubPage {
    id: number;
    slug: string;
    title: string | null;
    pageHeading: string | null;
    pageIntroduction: string | null;
    introductionTitle: string | null;
    introductionContent: string | null;
    introductionLinkText: string | null;
    introductionResourceUrl: string | null;
    sections: MarketingHubSection[];
}

export const MARKETING_HUB_LANDING_SLUG = 'marketing-hub';

export const LANDING_SECTION_PATHS: Record<number, string> = {
    1: '/marketinghub/brand-assets',
    2: '/marketinghub/promotional-kit',
    3: '/marketinghub/text-templates',
};

export function marketingHubPath(slug: string): string {
    return slug === MARKETING_HUB_LANDING_SLUG ? '/marketinghub' : `/marketinghub/${slug}`;
}

export function isMarketingHubLandingPath(pathname: string): boolean {
    return pathname === '/marketinghub'
        || pathname === '/marketinghub/'
        || pathname === `/marketinghub/${MARKETING_HUB_LANDING_SLUG}`;
}

export function isMarketingHubNavActive(slug: string, pathname: string): boolean {
    if (slug === MARKETING_HUB_LANDING_SLUG) {
        return isMarketingHubLandingPath(pathname);
    }
    return pathname === `/marketinghub/${slug}`;
}
